import React, {useState} from 'react';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import ViewSharedLinkFolderDialog from "./ViewSharedLinkFolderDialog";

function ViewSharedLinkFolderButton(props) {

    const [showDialog, setShowDialog] = useState(false)

    const handleClickIcon = () => {
        setShowDialog(true)
    };

    const handleCloseDialog = () => {
        setShowDialog(false)
    };


    const sharedLink = props.sharedLink;
    const actionConfig = props.actionConfig;

    const url = sharedLink && sharedLink.substring(0,sharedLink.indexOf("/s/")) + "/embed_widget" + sharedLink.substring(sharedLink.indexOf("/s/"));

    return (
        <React.Fragment>
            {
                sharedLink &&
                <div>
                    <Tooltip title={actionConfig.label}>
                        <IconButton
                            aria-label="Menu"
                            aria-haspopup="true"
                            color={"secondary"}
                            onClick={handleClickIcon}
                            size="medium">
                            <i className='material-icons'>
                                link
                            </i>
                        </IconButton>
                    </Tooltip>

                    {
                        showDialog &&
                        <ViewSharedLinkFolderDialog
                            sharedLink={url}
                            handleCloseDialog={handleCloseDialog}
                            actionConfig={props.actionConfig}
                        />
                    }

                </div>
             }
        </React.Fragment>
    );
}

ViewSharedLinkFolderButton.propTypes = {
    actionConfig: PropTypes.object.isRequired,
    sharedLink: PropTypes.string.isRequired
};

export default ViewSharedLinkFolderButton;